import * as Yup from 'yup';
import { useForm } from 'react-hook-form';

import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { Card, Grid, Box, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import { networkUpdateUserInfo } from 'src/network/users';
import GeneralUpload from 'src/components/general/GeneralUpload';
import { useQueryClient } from '@tanstack/react-query';
import { USER_LIST } from 'src/constants/queryKeys';
import useFormsModalStore from 'src/store/forms';

// ----------------------------------------------------------------------

export default function UserEdit() {
  const { modal, closeModal } = useFormsModalStore();

  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();


  const userDetails = modal?.data;


  // ----------------------------------------------------------------------

  const schema = Yup.object().shape({
    // ProfileName: Yup.string().required('وارد کردن نام الزامی است'),
    // ProfileLastName: Yup.string().required('وارد کردن نام خانوادگی الزامی است'),
    // ProfileMobile: Yup.string().required('وارد کردن شماره موبایل الزامی است'),
    // ProfileEmail: Yup.string().required('وارد کردن ایمیل الزامی است'),
    // ProfileUrlAvatar: Yup.string().required('انتخاب عکس آواتار الزامی است'),
  });

  const defaultValues = {
    ProfileName: userDetails?.ProfileName || '',
    ProfileLastName: userDetails?.ProfileLastName || '',
    ProfileEmail: userDetails?.ProfileEmail || '',
    ProfileMobile: userDetails?.ProfileMobile || '',
    ProfileUrlAvatar: userDetails?.ProfileAvatarDefault || '',
  };

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
    setValue,
    reset,
  } = methods;

  const onSubmit = async (values, event) => {
    const PAYLOAD = {
      ...values,
      ProfileName: values?.ProfileName,
      ProfileLastName: values?.ProfileLastName,
      ProfileEmail: values?.ProfileEmail,
      ProfileMobile: values?.ProfileMobile,
      ProfileUrlAvatar: values?.ProfileUrlAvatar,
      ApplicationID: userDetails?.ApplicationID,
      ProfilePassword: userDetails?.ProfilePassword,
      ProfileDeviceID: userDetails?.ProfileDeviceID,
    };

    try {
      await networkUpdateUserInfo(PAYLOAD);
      enqueueSnackbar('کاربر موردنظر با موفقیت ویرایش شد');
      if (event.nativeEvent.submitter.name === 'save') {
        closeModal();
        reset();
      }
      await queryClient.invalidateQueries({ queryKey: [USER_LIST] });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card sx={{ p: 3 }}>
            <Box
              sx={{
                display: 'grid',
                columnGap: 2,
                rowGap: 3,
                gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
              }}
            >
              <RHFTextField name="ProfileName" type="text" label="نام" />
              <RHFTextField name="ProfileLastName" type="text" label="نام خانوادگی" />
              <RHFTextField name="ProfileEmail" type="text" label="ایمیل" />
              <RHFTextField name="ProfileMobile" type="text" label="شماره موبایل" />

              <GeneralUpload
                id={'user_avatar_image'}
                name="ProfileUrlAvatar"
                label="آواتار کاربر"
                afterChangeAction={(res) => setValue('ProfileUrlAvatar', res)}
              />
            </Box>

            <div className="flex items-center gap-4 mt-6">
              <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
                ذخیره
              </LoadingButton>
              <LoadingButton type="submit" variant="contained" color="info" name="saveAndContinue" loading={isSubmitting}>
                ذخیره و ادامه ویرایش
              </LoadingButton>
              <Button onClick={closeModal} variant="contained" color="error">
                انصراف
              </Button>
            </div>
          </Card>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
